import styled from "@emotion/styled";
import React, { useRef, useState } from "react";
import Select from "react-dropdown-select";
import { Image, Text as RNText, StyleProp, TextStyle, TouchableOpacity, View } from "react-native";
import { useVirtualizer } from "@tanstack/react-virtual";
import { FONT_FAMILY, FONT_SIZE, OTHER_CONSTANTS, THEME_COLORS } from "../../themes";
import { getDeepSearchedItems } from "../../../common/helper";
import Text from "../CustomTextComponent";

export type SelectInputVarsType = {
  labelField: string;
  valueField: string;
  searchBy: string;
  fieldName: string;
  options: object[];
};
type ICustomSelectProps = {
  label?: string;
  multi?: boolean;
  level?: string;
  hideSelectField?: string;
  labelStyles?: any;
  isRequired?: boolean;
  disabled?: boolean;
  values: object[];
  isLabelVisible?: boolean;
  filterObj?: any;
  filterHandler?: (data, search, obj) => any;
  type?: "select" | "filter";
  onChange: (value) => void;
  onSearch?: (searchInput: string) => void;
  closeOnSelect?: boolean;
  isClearVisible?: boolean;
  width?: number|string;
  height?: number;
  backgroundColor?: string;
  virtualized?: boolean;
  rowHeight?: number;
  renderItem?: (data: { option: object; isCheckboxVisible: boolean }) => JSX.Element;
  keyField?: string;
  style?: any;
  placeholderTxtStyle?: StyleProp<TextStyle>;
  boldField?: string;
} & SelectInputVarsType;

export const CustomSelectTwo = (props: ICustomSelectProps) => {
  const isLabelVisible = !!props.isLabelVisible ?? false;
  const type = !!props.type ? props.type : "select";
  const isHideSelectInProps = !!props.hideSelectField;
  const hideSelectField = props.hideSelectField;
  const isClearVisible = type === "filter" || (!!props.isClearVisible ? props.isClearVisible : false);
  const virtualized = !!props.virtualized ? props.virtualized : false;
  const filterObj = props.filterObj;
  const placeholderTxtStyle = props.placeholderTxtStyle ?? {};
  // const customStyle=props.style
  const level = props.level;
  const filterHandler = props.filterHandler;
  const onSearch = props.onSearch;
  const key = !!props.keyField ? props.keyField : props.valueField;

  

  const selectStyles =
    type === "filter"
      ? { border: 0 }
      : isLabelVisible
        ? {
            minHeight: "auto",
            paddingVertical: 5,
            border: "none",
          }
        : {
            minHeight: "auto",
            boxShadow: `0 0 10px 0 ${THEME_COLORS.shadow1}`,
            padding: 0,
            width: !!props.width ? props.width : "auto",
            marginTop: 5,
            marginBottom: 5,
            backgroundColor: THEME_COLORS.white,
            borderRadius: 10,
            borderColor: props.isRequired && !(props.values.length > 0) ? THEME_COLORS.red : THEME_COLORS.black2,
            ...(props.style || {}),
          };
  const renderItem = (option: object, isCheckboxVisible) => {
    return !!props.renderItem ? (
      props.renderItem({ option, isCheckboxVisible })
    ) : (
      <ItemLabel
        style={{
          fontFamily: isCheckboxVisible
            ? !!option[props.boldField]
              ? "FuturaPTMedium"
              : "FuturaPTBook"
            : "FuturaPTMedium",
        }}
      >
        {option[props.labelField]}
      </ItemLabel>
    );
  };
  const onSearchFn = ({ props, state, methods }) => {
    if (!!!onSearch) {
      let filteredData = getDeepSearchedItems(props.options, state.search, props.searchBy || props.labelField);
      filteredData = !!filterHandler ? filterHandler(filteredData, state.search, filterObj) : filteredData;
      return filteredData;
    } else {
    }
  };
  const renderItemList = ({ filteredData, methods, state, props }) => {
    return (
      <Items>
        {filteredData.map((option, index) => {
          if (!props.keepSelectedInList && methods.isSelected(option)) {
            return null;
          }

          const isCursorOnThisOption = state.cursor === index;
          const isOptionSelected =
            props.values?.length &&
            state.values.map((item) => item[props.valueField]).indexOf(option[props.valueField]) !== -1;
          const isCheckboxVisible = isHideSelectInProps ? option[hideSelectField] : true;
          return (
            <Item
              disabled={option.disabled}
              key={option[key]}
              ref={(r) => {
                r && isCursorOnThisOption ? r.scrollIntoView({ block: "center", behavior: "smooth" }) : null;
                if (r)
                  r.onclick = () => {
                    option.disabled || !isCheckboxVisible ? null : methods.addItem(option);
                  };
              }}
              style={{
                backgroundColor: isCursorOnThisOption ? THEME_COLORS.purple3 : null,
                borderRadius: 4,
                alignItems: "center",
                cursor: isCheckboxVisible ? "pointer" : null,
                maxWidth: "200px",
                color: isCursorOnThisOption ? THEME_COLORS.white : null,
                marginLeft: option[level] ? option[level] * 10 : 0,
              }}
            >
              {isCheckboxVisible ? (
                <StyledCheckboxInput readOnly={true} type="checkbox" checked={isOptionSelected} />
              ) : null}
              {renderItem(option, isCheckboxVisible)}
            </Item>
          );
        })}
      </Items>
    );
  };

  const renderItemListVirtualized = ({ filteredData, methods, state, props }) => {
    return (
      <VirtualizedDropdownListCustomSelectTwo
        filteredData={filteredData}
        methods={methods}
        state={state}
        props={props}
        renderItem={renderItem}
        hideSelectField={hideSelectField}
        isHideSelectInProps={isHideSelectInProps}
        level={level}
      />
    );
  };

  const renderList = virtualized ? renderItemListVirtualized : renderItemList;

  const customDropdownRenderer = ({ props, state, methods }) => {
    const filteredData = methods.searchResults();
    
    const areAllSelected = (() => {
      if (filteredData.length === 0 || state.values.length < filteredData.length) {
        return false;
      }

      for (let i in filteredData) {
        if (!state.values.find((val) => val.id === filteredData[i].id)) {
          return false;
        }
      }

      return true;
    })();

    return (
      <DropDown>
        <SearchAndToggle color={props.color}>
          <Buttons>
            {
              props.multi && (
                <Button
                  className="select-all"
                  style={{
                    flexDirection: "row",
                    justifyContent: "flex-end",
                    backgroundColor:
                      !!props?.values && !!!(props?.values?.[0]?.id === "3131") ? null : THEME_COLORS.excelGreen,
                    color: !!props?.values && !!!(props?.values?.[0]?.id === "3131") ? null : THEME_COLORS.bgWhite,
                  }}
                  ref={(r) => {
                    if (r)
                      r.onclick = () => {
                        let oldVals = state.values.map((item) => item[props.valueField]);
                        let filteredNewData = filteredData.filter((item) => !oldVals.includes(item[props.valueField]));
                        let newfilter = filteredData.filter((item) => item[props.valueField] !== "3131");
                        if (areAllSelected) {
                          methods.clearAll();
                          return;
                        }
                        methods.selectAll(newfilter);
                        // if(!!props?.values && !!!(props?.values?.[0]?.id === "3131")) {
                        //   methods.selectAll([...state.values,...newfilter]);
                        // }else methods.clearAll();
                      };
                  }}
                >
                  Select All
                </Button>
              )
              // <Image source={images.tableArrow} style={{tintColor:THEME_COLORS.black2, width:20}}
              // style={{tintColor :props.values.length <= 0 ? null : THEME_COLORS.bgWhite  }}
              // />
            }
            {props.values.length > 0 && !!props?.values && !!!(props?.values?.[0]?.id === "3131") && isClearVisible ? (
              <Button
                className="clear"
                style={{ justifyContent: "flex-end" }}
                ref={(r) => {
                  if (r)
                    r.onclick = () => {
                      methods.clearAll();
                    };
                }}
                onClick={methods.clearAll}
              >
                Clear
              </Button>
            ) : (
              <></>
            )}
          </Buttons>
          <input
            style={{ border: "none", backgroundColor: THEME_COLORS.grey2 }}
            autoFocus={true}
            type="text"
            value={state.search}
            onChange={(v) => {
              methods.setSearch(v);
            }}
            placeholder={"Search " + props.fieldName}
          />
        </SearchAndToggle>
        {renderList({ filteredData, props, methods, state })}
      </DropDown>
    );
  };
  const customDropdownRendererUniversal = ({ props, state, methods }) => {
    const filteredData = methods.searchResults();
    const isUniversalSelected = props?.values?.[0]?.id === "3131";

    const isFilterAdded =
      filterObj?.fuelFilterValues?.length > 0 ||
      filterObj?.makeFilterValues?.length > 0 ||
      filterObj?.yearFilterValues?.length > 0;

    const areAllSelected = (() => {
      if (filteredData.length === 0 || state.values.length < filteredData.length) {
        return false;
      }

      for (let i in filteredData) {
        if (!state.values.find((val) => val.id === filteredData[i].id)) {
          return false;
        }
      }

      return true;
    })();

    const isUniversalDisabled = (): boolean => {
      return state.values.length > 0 && state.values?.[0]?.modelName?.toLowerCase() !== "universal";
    };

    return (
      <DropDown>
        <SearchAndToggle color={props.color} style={{ marginTop: 10 }}>
          <View
            style={{
              flexDirection: "row",
              paddingHorizontal: 20,
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            {props.multi && (
              <View style={{ alignSelf: "flex-start" }}>
                <TouchableOpacity
                  style={{
                    marginEnd: 10,
                    paddingVertical: 4,
                    paddingHorizontal: 10,
                    borderRadius: 4,
                    borderWidth: 1,
                    borderColor: "green",
                    backgroundColor: isUniversalSelected ? "green" : "white",
                    opacity: isUniversalDisabled() ? 0.4 : 1,
                    cursor: isUniversalDisabled() ? "default" : "pointer",
                  }}
                  disabled={isUniversalDisabled()}
                  onPress={() => {
                    let oldVals = state.values.map((item) => item[props.valueField]);
                    let filteredNewData = filteredData.filter((item) => !oldVals.includes(item[props.valueField]));
                    let newfilter = filteredData.find((item) => item[props.valueField] === "3131");
                    if (!!props?.values && !!!(props?.values?.[0]?.id === "3131")) {
                      methods.selectAll([
                        { displayName: " Universal  ", engineType: "", id: "3131", modelName: "Universal" },
                      ]);
                      // methods.selectAll([...state.values,...newfilter]);
                    } else methods.clearAll();
                  }}
                >
                  <RNText
                    style={{
                      fontFamily: FONT_FAMILY.two,
                      fontSize: 12,
                      color: isUniversalSelected ? "white" : "green",
                    }}
                  >
                    Universal
                  </RNText>
                </TouchableOpacity>
                <TouchableOpacity
                  style={{
                    marginTop: 10,
                    paddingVertical: 4,
                    paddingHorizontal: 10,
                    borderRadius: 4,
                    borderWidth: 1,
                    borderColor: "green",
                    backgroundColor: areAllSelected ? "green" : "white",
                    alignSelf: "flex-start",
                    opacity: isUniversalSelected || (!!!state.search && !isFilterAdded) ? 0.4 : 1,
                  }}
                  disabled={isUniversalSelected || (!!!state.search && !isFilterAdded)}
                  onPress={() => {
                    if (areAllSelected) {
                      methods.clearAll();
                      return;
                    }
                    let newfilter = filteredData.filter((item) => item[props.valueField] !== "3131");
                    methods.selectAll(newfilter ? [...state.values, ...newfilter] : state.values);
                  }}
                >
                  <RNText
                    style={{ fontFamily: FONT_FAMILY.two, fontSize: 12, color: areAllSelected ? "white" : "green" }}
                  >
                    Select All
                  </RNText>
                </TouchableOpacity>
              </View>
            )}
            {props.values.length > 0 && !!props?.values && !!!(props?.values?.[0]?.id === "3131") && isClearVisible ? (
              <Button
                className="clear"
                style={{ alignSelf: "center", justifyContent: "flex-end" }}
                ref={(r) => {
                  if (r)
                    r.onclick = () => {
                      methods.clearAll();
                    };
                }}
                onClick={methods.clearAll}
              >
                Clear
              </Button>
            ) : !!props.multi ? (
              <></>
            ) : (
              props.values.length > 0 &&
              !!props?.values && (
                <Button
                  className="clear"
                  style={{ justifyContent: "flex-end" }}
                  ref={(r) => {
                    if (r)
                      r.onclick = () => {
                        methods.clearAll();
                      };
                  }}
                  onClick={methods.clearAll}
                >
                  Clear
                </Button>
              )
            )}
          </View>
          <input
            style={{ border: "none", backgroundColor: THEME_COLORS.grey2 }}
            autoFocus={true}
            type="text"
            value={state.search}
            onChange={(v) => {
              methods.setSearch(v);
            }}
            placeholder={"Search " + props.fieldName}
          />
        </SearchAndToggle>
        {renderList({ filteredData, props, methods, state })}
      </DropDown>
    );
  };

  const className = "css-1ujv2ml-ReactDropdownSelect";
  let element = document.getElementById(className);
  if (!!!element) {
    element = document.createElement("div");
    element.setAttribute("id", className);
    element.setAttribute("class", className);
    element.setAttribute("style", "width: 0%; padding: 0px; z-index: 99999 !important");
    document.body.appendChild(element);
  }
  let closeOnSelect = true;
  if (!!props.multi && props.multi) {
    closeOnSelect = false;
  } else if (!!props.closeOnSelect) {
    closeOnSelect = props.closeOnSelect;
  }
  const renderStyledSelect = () => (
    <StyledSelect
      backspaceDelete={false}
      labelField={props.labelField}
      valueField={props.valueField}
      searchBy={props.searchBy}
      dropdownPosition="auto"
      values={props.values}
      options={props.options}
      rowHeight={props.rowHeight}
      onChange={props.onChange}
      multi={props.multi}
      closeOnSelect={closeOnSelect}
      disabled={props.disabled}
      dropdownHeight={"400px"}
      dropdownHandle={type !== "filter"}
      color={THEME_COLORS.primary}
      style={selectStyles}
      searchFn={onSearchFn}
      clearOnSelect={false}
      fieldName={props.fieldName}
      contentRenderer={({ props, state }) => {
        const values = props.values;
        const valuesLength = values.length;
        const isValueSelected = valuesLength > 0;
        let showValues = values;
        const maxVisibleValues = 2;
        if (isValueSelected && valuesLength > maxVisibleValues) {
          showValues = values.slice(0, maxVisibleValues);
        }
        const extraLength = valuesLength - maxVisibleValues;
        const showText = isValueSelected
          ? `${showValues.map((item) => item[props.labelField]).join(", ")}`
          : "Select " + props.fieldName;
        return type === "filter" ? (
          isValueSelected ? (
            <Image source={require("../../../assets/filterIcon.ico")} style={{ width: 15, height: 12 }} />
          ) : (
            <Image source={require("../../../assets/filter_icon.png")} style={{ width: 15, height: 12 }} />
          )
        ) : (
          <>
            <Text style={placeholderTxtStyle} numberOfLines={2} fontSize={"medium"} type_of_six={"three_six"}>
              {showText}
            </Text>
            {extraLength > 0 ? (
              <Text fontSize={"small"} type_of_six={"two_six"} style={{ color: THEME_COLORS.success }}>
                {" "}
                + {extraLength} more
              </Text>
            ) : null}
          </>
        );
      }}
      portal={typeof document !== `undefined` && element}
      dropdownRenderer={virtualized ? customDropdownRendererUniversal : customDropdownRenderer}
    />
  );

  return !isLabelVisible ? (
    renderStyledSelect()
  ) : (
    <View
      style={{
        width: !!props.width ? props.width : 250,
        backgroundColor: !!props.backgroundColor ? props.backgroundColor : THEME_COLORS.grey2,
        height: 70,
        paddingHorizontal: 10,
        borderRadius: 8,
        marginLeft: 10,
        marginVertical: 10,
      }}
    >
      <Text style={[{ marginVertical: 5 }, props.labelStyles ?? {}]} fontSize={"medium"}>
        {props.label ?? ""}
      </Text>
      {renderStyledSelect()}
    </View>
  );
};

const Title = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
`;

const StyledSelect = styled(Select)`
  .react-dropdown-select-dropdown {
    // position: absolute;
    // left: 0;
    // border: none;
    width: fit-content !important;
    // padding: 0;
    // display: flex;
    // flex-direction: column;
    // border-radius: 2px;
    // overflow: auto;
    z-index: 9999999 !important;
    // background: #333;
    //color: #fff !important;
  }
  .react-dropdown-select-content {
    font-size: ${FONT_SIZE.s2};
    padding-left: 5px;
    align-content: center;
    min-height: ${OTHER_CONSTANTS.selectInputHeight};
    font-family: ${FONT_FAMILY.primary};
  }
`;

const SearchAndToggle = styled.div`
  display: flex;
  flex-direction: column;
  input {
    margin: 10px 10px 0;
    line-height: 30px;
    padding: 0px 20px;
    border: 1px solid #ccc;
    border-radius: 3px;
    :focus {
      outline: none;
      border: 1px solid ${THEME_COLORS.purple3};
    }
  }
`;

const Items = styled.div`
  overflow: auto;
  min-height: 10px;
  max-height: 200px;
`;

const TouchableOpacityG = styled(TouchableOpacity)`
  :hover {
    ${({ disabled }) => !disabled && "background: #f2f2f2; "}
  }
  // ${({ disabled }) => disabled && "text-decoration: line-through;"}
`;

const Item = styled.div`
  display: flex;
  margin: 5px;
  align-items: baseline;
  font-family: ${FONT_FAMILY.primary};
  font-size: ${FONT_SIZE.s2};
  :hover {
    ${({ disabled }) => !disabled && "background: #f2f2f2; "}
  }
  // ${({ disabled }) => disabled && "text-decoration: line-through;"}
`;

const StyledCheckboxInput = styled.input``;

const ItemLabel = styled.div`
  margin: 5px 10px;
`;

const VirtualizedListContainer = styled.div`
  overflow: auto;
  min-height: 10px;
  max-height: 150px;
  height: 150px;
  width: 300px;
`;

const VirtualizedListInner = styled.div`
  position: relative;
  width: 100%;
`;

const Buttons = styled.div`
  display: flex;
  justify-content: space-between;
  & div {
    margin: 10px 0 0 10px;
    font-weight: 600;
  }
`;

const Button = styled.button`
  background: none;
  border: 1px solid #555;
  color: #555;
  border-radius: 3px;
  margin: 10px 10px 0;
  padding: 3px 5px;
  font-size: 10px;
  text-transform: uppercase;
  cursor: pointer;
  outline: none;
  &.clear {
    color: tomato;
    border: 1px solid tomato;
  }
  &.select-all {
    color: green;
    border: 1px solid green;
  }
  &.select-all-a {
    color: green;
    border: 1px solid green;
    .css-1eiq1t9.select-all{
      color:white,
      width:10px,
      height:10px
    }
  }
`;

const DropDown = styled.div`
  .css-1snwlti-DropDown {
    min-width: 100;
  }
`;

function VirtualizedDropdownListCustomSelectTwo({
  filteredData,
  methods,
  state,
  props: listProps,
  renderItem,
  hideSelectField,
  isHideSelectInProps,
  level,
}: {
  filteredData: object[];
  methods: any;
  state: any;
  props: any;
  renderItem: (option: object, isCheckboxVisible: boolean) => React.ReactNode;
  hideSelectField?: string;
  isHideSelectInProps: boolean;
  level?: string;
}) {
  const rowHeight = listProps.rowHeight || 36;
  const listRef = useRef<HTMLDivElement>(null);
  const rowVirtualizer = useVirtualizer({
    count: filteredData.length,
    getScrollElement: () => listRef.current,
    estimateSize: () => rowHeight,
    overscan: 10,
  });
  return (
    <DropDown>
      <VirtualizedListContainer ref={listRef}>
        <VirtualizedListInner style={{ height: rowVirtualizer.getTotalSize() }}>
          {rowVirtualizer.getVirtualItems().map((virtualRow) => {
            const option = filteredData?.[virtualRow.index] as any;
            if (!option) return null;
            if (!listProps.keepSelectedInList && methods.isSelected(option)) {
              return null;
            }
            const isCursorOnThisOption = state.cursor === virtualRow.index;
            const isOptionSelected =
              listProps.values?.length &&
              listProps.values.map((item: any) => item[listProps.valueField]).indexOf(option[listProps.valueField]) !== -1;
            const isCheckboxVisible = isHideSelectInProps ? option[hideSelectField] : true;
            return option.id === "3131" && !!listProps.multi ? null : (
              <TouchableOpacityG
                key={virtualRow.key}
                disabled={option.disabled}
                ref={(r: any) => {
                  if (r) {
                    isCursorOnThisOption ? r.scrollIntoView({ block: "center", behavior: "smooth" }) : null;
                    (r as HTMLElement).onclick = () => {
                      if (!(option.disabled || !isCheckboxVisible)) {
                        if (!!listProps?.values && listProps?.values?.[0]?.id === "3131" && listProps.multi) return;
                        else methods.addItem(option);
                      }
                    };
                  }
                }}
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: virtualRow.size,
                  transform: `translateY(${virtualRow.start}px)`,
                  backgroundColor: isCursorOnThisOption ? THEME_COLORS.purple3 : undefined,
                  borderRadius: 4,
                  alignItems: "center",
                  flexDirection: "row",
                  cursor: isCheckboxVisible ? "pointer" : undefined,
                  color: isCursorOnThisOption ? THEME_COLORS.white : undefined,
                  marginLeft: option[level] ? option[level] * 10 : 0,
                }}
              >
                {isCheckboxVisible ? (
                  <StyledCheckboxInput
                    type="checkbox"
                    readOnly={true}
                    onChange={undefined}
                    checked={isOptionSelected}
                  />
                ) : null}
                <Text
                  style={{
                    color:
                      !!listProps?.values && listProps?.values?.[0]?.id === "3131" && listProps.multi
                        ? THEME_COLORS.grey0
                        : undefined,
                  }}
                >
                  {renderItem(option, isCheckboxVisible)}
                </Text>
              </TouchableOpacityG>
            );
          })}
        </VirtualizedListInner>
      </VirtualizedListContainer>
    </DropDown>
  );
}
